/**
 * @generated SignedSource<<2188a54e247469089c00b9f09d329eac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedBestsellingDesignsCarousel_viewer" | "HpSharedExcellentValuesCarousel_viewer" | "HpSharedMostSavedItemsCarousel_viewer">;
  readonly " $fragmentType": "HpSharedLocationsModule_viewer";
};
export type HpSharedLocationsModule_viewer$key = {
  readonly " $data"?: HpSharedLocationsModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedMostSavedItemsCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedExcellentValuesCarousel_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpSharedBestsellingDesignsCarousel_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3fe62aa3298ff6d1e60c5ee729657fe2";

export default node;
